
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dz89i", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.df9de9d0.js.map
